export default __webpack_public_path__ + "static/media/Kategori Produk-BIOCHEF-2.224578fb.jpg";